import { Facebook, Twitter, Linkedin, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { useSettings } from "@/context/SettingsContext";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SocialShare({ url, title, className = "" }) {
  const { settings } = useSettings();
  const fullUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const encoded = encodeURIComponent(fullUrl);
  const text = encodeURIComponent(title || `Check this out on ${settings.site_name || "HyderabadTourism.in"}`);

  const shares = [
    { name: "WhatsApp", key: "whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${text}%20${encoded}`, color: "text-[#25D366]" },
    { name: "Facebook", key: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}`, color: "text-[#1877F2]" },
    { name: "X / Twitter", key: "twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${encoded}&text=${text}`, color: "text-foreground" },
    { name: "LinkedIn", key: "linkedin", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`, color: "text-[#0A66C2]" },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Could not copy");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className={className} data-testid="share-btn">
          <Share2 className="w-4 h-4 mr-1.5" /> Share
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {shares.map((s) => (
          <DropdownMenuItem
            key={s.key}
            onClick={() => window.open(s.href, "_blank", "noopener")}
            data-testid={`share-${s.key}`}
          >
            <s.icon className={`w-4 h-4 mr-2 ${s.color}`} />
            {s.name}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem onClick={copy} data-testid="share-copy">
          <Link2 className="w-4 h-4 mr-2 text-teal" />
          Copy Link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
